'use strict';
const angular = require('angular');

export class ReportFilterModalComponent {
  /*@ngInject*/
  constructor($scope, $uibModal) {
    this.$scope = $scope;
    this.$uibModal = $uibModal;

    this.model = {};
    this.$scope.model = this.model;

    this.mapFileType = {
      'docx': "Word Document (DOCX)",
      'odt': 'Open Office Document (ODT)',
      'pdf': 'Portable Document Format (PDF)'
    };

    $scope.$watch("model", _ => this.filterb64 = btoa(JSON.stringify(this.model)), true);
  }

  $onInit() {
    this.config = this.resolve.config;
    this.icon = this.config.icon || 'download';

    let filetypes = this.config.fileTypes || ["docx"];
    this.fileTypes = filetypes.map(fileType => { return {fileType: fileType, name: this.mapFileType[fileType]} });

    this.model.report = this.config.report;
    this.model.template = this.config.template;
    this.model.fileType = this.config.defaultFileType || "docx";

    this.model.voterGroupId = this.config.voterGroupId;
    
    this.filterb64 = btoa(JSON.stringify(this.model));
  };

  ok(model) {
    this.close({$value: model});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  getContactTypeName(type) {
    switch(type) {
      case 'primary-owner':
        return "Primary Owner";
      case 'owner':
        return "Owner";
      case 'renter':
        return "Renter";
      case 'previous-owner':
        return "Previous Owner";
      case 'visitor':
        return "Visitor";
      default:
        return type;
    }
  }

  updateModelContactTypes() {
    let selectedContactTypes = [];
    this.contactTypes.forEach(type => {
      if (this.contactTypesMap[type])
        selectedContactTypes.push(type);
    });
    this.model.contactTypes = selectedContactTypes;
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    this.$scope.$broadcast('schemaFormValidate');

    if (form.$valid) {
      this.ok(this.model);
    }
  }
}

export default angular.module('conduuApp.reportFilterModal', [])
  .component('reportFilterModal', {
    template: require('./report-filter-modal.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: ReportFilterModalComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/report-filter-modal/report-filter-modal.component.js